// Date转化为YYYY-MM-DD
export function dateFormat (d, sign) {
  // 如果没有传递符号，给一个默认的符号
  if (!sign) sign = '-'
  const year = d.getFullYear()
  const month = d.getMonth() + 1
  const sun = d.getDate()
  const temp = year + sign + this.mendZero(month) + sign + this.mendZero(sun)
  return temp
}

// 时间转换补零
export function mendZero (num) {
  return (num = num < 10 ? '0' + num : num)
}